import { map } from 'lodash';
import numeral from 'numeral';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, NavbarBrand, Table } from 'reactstrap';
import { gql, useQuery } from 'urql';
import useTerminalHazardClassSummary from '../hooks/useTerminalHazardClassSummary';
import styled from '../themes/themed-styled-components';
import { Terminal } from '../types/graph';
import CenteredContainer from './CenteredContainer';
import Loading from './Loading';
import { GridLayout } from './ui';

const Col = styled.col`
    r:nth-child(2n+1) {
        background-color: #ccc;
    }
`

type QueryData = { terminal: Terminal };
type QueryArguments = { id: number };

const StyledTable = styled(Table)`
    margin-bottom: 0;
    & th, & td {
        vertical-align: middle;
    }
    tbody {
        tr:nth-child(4n+1),
        tr:nth-child(4n+2) {
            td[rowspan="2"],
            th[rowspan="2"] {
               background-color: rgba(0,0,0,.05);
            }
        }
        tr:nth-child(2n) td:not([rowspan]) {
           background-color: rgba(0,0,0,.05);
        }
    }
`;

type TerminalHazardClassSummaryCardProps = {
    id: number
}

const query = gql<QueryData, QueryArguments>`
query terminal($id: Int!) {
    terminal (id: $id) {
        id
        name
        slug
        handlings {
            id
            checkedIn
            checkedOut
            type
            loadingUnitSize
            loadingUnitSizeFromGate
            dangerousGoods {
                id
                adrClass
            }
        }
    }
}
`;

const TerminalHazardClassSummaryCard = ({ id }: TerminalHazardClassSummaryCardProps) => {

    const { t } = useTranslation('common');

    const [result] = useQuery<QueryData, QueryArguments>({
        query: query,
        variables: { id/*, types: [HandlingType.None, HandlingType.Boarding, HandlingType.Unboarding, HandlingType.TranshipmentBoarding, HandlingType.TranshipmentUnboarding]*/ }
    });


    const { data, fetching/*, error*/ } = result;

    const terminal = data?.terminal;

    const separateTeus = terminal?.name === 'VOLTRI';

    const counters = useTerminalHazardClassSummary({ terminal });

    if (fetching) {
        return <CenteredContainer>
            <Loading />
        </CenteredContainer>;
    }

    const header = <Navbar className="navbar ng-white border-bottom box-shadow" light>
        <div>
            <NavbarBrand>{t('Conteggio TEU')}</NavbarBrand>
        </div>
        <div className="d-sm-inline-flex flex-sm-row">

        </div>
        <div className="navbar-right d-sm-inline-flex flex-sm-row">

        </div>
    </Navbar>

    return <GridLayout header={header}>
        {fetching ?

            <CenteredContainer>
                <Loading />
            </CenteredContainer>

            :

            <StyledTable style={{ textAlign: 'center', verticalAlign: 'middle' }} striped>

                <thead style={{ position: 'sticky', top: 0, background: 'rgba(255,255,255,.65)', zIndex: 10 }}>
                    <tr>
                        <th>Classe</th>
                        <th colSpan={3}>A&nbsp;piazzale</th>
                        <th colSpan={3}>Previsti</th>
                        <th colSpan={3}>Totali</th>
                    </tr>
                </thead>

                <tbody>
                    {map(counters, (s, adrClass) =>
                        <Fragment key={adrClass}>
                            <tr>
                                <th scope="row" rowSpan={separateTeus ? 2 : undefined} style={{ position: 'sticky', left: 0 }}>{adrClass}</th>
                                {map(s, ([teus, oneTeu], type) =>
                                    <Fragment key={type}>
                                        <td colSpan={separateTeus ? undefined : 3} rowSpan={separateTeus ? 2 : undefined}>{`${numeral(teus).format()} TEU`}</td>
                                        {separateTeus && <>
                                            <th>20'</th>
                                            <td>{oneTeu}</td>
                                        </>}
                                    </Fragment>
                                )}
                            </tr>
                            <tr>
                                {map(s, ([_teus, _oneTeu, twoTeus], type) =>
                                    <Fragment key={type}>
                                        {separateTeus && <>
                                            <th>40'</th>
                                            <td>{twoTeus}</td>
                                        </>}
                                    </Fragment>
                                )}
                            </tr>
                        </Fragment>
                    )}
                </tbody>
            </StyledTable>

        }
    </GridLayout>

};


export default TerminalHazardClassSummaryCard;

